<template>

    <div class="codebox">
        <v-button size="xs" btn-style="white" title="Copy" @click.native="copyText">
            <i v-if="!copied" class="fas fa-clipboard"></i>
            <i v-else class="fas fa-clipboard-check text-success"></i>
        </v-button>
        <pre ref="pre" v-highlightjs="code"><code ref="code" :class="language"></code></pre>
    </div>

</template>

<style lang="scss">

    @import "@sass/_variables.scss";

    .hljs-attr { color: $color-text; }
    .hljs-built_in { color: teal; }
    .hljs-comment { color: $color-muted; }
    .hljs-keyword { color: teal; }
    .hljs-name { color: $color-primary; }
    .hljs-number { color: $color-danger; }
    .hljs-params { color: $color-text; }
    .hljs-string { color: $color-danger; }
    .hljs-tag { color: $color-text; }

</style>

<style scoped lang="scss">

    @import "@sass/_variables.scss";

    .codebox {
        border: 1px solid $color-rule;
        border-radius: 5px;
        overflow: hidden;
        position: relative;
        button {
            margin: 5px;
            position: absolute;
            right: 0;
            top: 0;
            z-index: 1;
        }
        pre {
            background: $color-bg;
            border: none;
            border-radius: 3px;
            box-sizing: border-box;
            color: $color-text;
            font-family: monospace;
            font-size: 12px;
            line-height: 1.8em;
            margin: 0;
            overflow: auto;
            padding: 40px 20px 20px 20px;
            text-size-adjust: 100%;
            word-wrap: pre;
        }
    }

</style>

<script>

import Vue from 'vue';
import VueHighlightJS from 'vue-highlightjs';
Vue.use(VueHighlightJS);

export default {

    props: {
        code: {
            type: String,
            required: true,
        },
        language: {
            type: String,
            default: 'html',
        },
        editable: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            copied: false,
            render: true,
        }
    },

    methods: {

        copyText() {
            navigator.clipboard.writeText(this.code)
                .then(() => {
                    this.$store.commit('setAlertSuccess', this.$t('message.copied'));
                    this.copied = true;
                })
                .catch(() => {
                    this.$store.commit('setAlertError', 'Unable to copy text.');
                });
        },

    },

}

</script>
